<script>
  export default {
    // prefix: '/apis',
    prefix: 'https://api.cityhouse.cn',
    //apiKey: '086657051da5a03a6c6c6ae4f5602c3f',
    uid: 'guochengqian',
    pwd: 'test2018.',
    // prefix: 'http://api-test.cityhouse.cn',
    // apiKey: 'jwfiefwpfe2328432r23r98203e',
    // uid: 'test002',
    // pwd: '123456',
    
  }
</script>


// WEBPACK FOOTER //
// src/components/global/index.vue